import { useContext } from "react";
import { motion } from "framer-motion";
import { Claim, EASE, GoldRule, InstantContext, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const Kpi = ({ value, label, delay }) => (
  <Reveal delay={delay}>
    <div className="tnum font-serif text-6xl tracking-tight text-[#D4AF37] lg:text-7xl">{value}</div>
    <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.28em] text-white/45">{label}</div>
  </Reveal>
);

export default function Slide11Scaling() {
  const instant = useContext(InstantContext);
  return (
    <SlideShell theme="navy" testid="slide-11-scaling">
      <SlideBody>
        <Reveal>
          <Micro>10 · Scaling 2028</Micro>
        </Reveal>
        <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>
            IL MODELLO <em className="italic text-[#D4AF37]">SCALA.</em>
          </MaskedLine>
        </h2>

        <div className="mt-14 grid gap-10 sm:grid-cols-3">
          <Kpi value="100" label="Ville nella Collection" delay={0.35} />
          <Kpi value="€100K" label="Piano ADV 2028" delay={0.5} />
          <Kpi value="≈ €1.000" label="Per villa · all'anno" delay={0.65} />
        </div>

        <div className="mt-16 max-w-3xl">
          <div className="flex justify-between font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
            <span>2026 · 20 ville</span>
            <span className="text-[#D4AF37]">2028 · 100 ville</span>
          </div>
          <div className="relative mt-3 h-px bg-white/15">
            <motion.div
              className="absolute inset-y-0 left-0 bg-[#D4AF37]"
              initial={instant ? false : { width: "20%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.8, delay: instant ? 0 : 0.9, ease: EASE }}
            />
          </div>
        </div>

        <Reveal delay={1.1} className="mt-14 flex items-center gap-5">
          <GoldRule delay={1.1} />
          <Claim>Prenota nelle 100 migliori ville della Costiera Amalfitana.</Claim>
        </Reveal>
      </SlideBody>
    </SlideShell>
  );
}
